export const ALLOW_REMOVE_LAST_FAVORITE_STORE = true;
